import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchSettings = () => {
  const response = useQuery({
    queryKey: ['settingsSwitch'],
    queryFn: () => api.settings.fetchSwitch(),
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить настройки',
      type: 'error',
    })
  }

  return response
}
